import { useEffect, useState } from "react";

import { Icon } from "../../../../Elements/Icon";

import * as styles  from "./styles.module.scss";
import { AnimatedIcon } from "./AnimatedIcon";

export const Compact = ({
    guide,
    language,
    version,
    track,
    onToggle,
    onClose,
}) => {
    const [playing, setPlaying] = useState(false);

    const handlePlayPause = () => {
        setPlaying((state) => !state);
        window.audioplayer.playPause();
    };

    useEffect(() => {
        setPlaying(window.audioplayer.meta().playing);

        const playListener = () => setPlaying(true);
        const pauseListener = () => setPlaying(false);

        window.audioplayer.addEventListener("play", playListener);
        window.audioplayer.addEventListener("pause", pauseListener);
        window.audioplayer.addEventListener("reset", pauseListener);

        return () => {
            window.audioplayer.removeEventListener("play", playListener);
            window.audioplayer.removeEventListener("pause", pauseListener);
            window.audioplayer.removeEventListener("reset", pauseListener);
        };
    }, []);

    return (
        <div className={styles.compact}>
            <div className={styles.icon}>
                <button type="button" className={styles.button} onClick={onToggle}>
                    <AnimatedIcon />
                </button>
            </div>

            <div className={styles.title}>
                <button type="button" className={styles.button} onClick={onToggle}>
                    {track?.title ?? version?.title ?? language?.title ?? guide?.title}
                </button>
            </div>

            <div className={styles.controls}>
                <button type="button" className={styles.button} onClick={handlePlayPause}>
                    <Icon name={playing ? "pause" : "play"} width="16" height="20" />
                </button>

                <button type="button" className={styles.button} onClick={onClose}>
                    <Icon name="close" width="16" height="16" />
                </button>
            </div>
        </div>
    );
};
